var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEyeNotAllowed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-eye__not-allowed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IBM-Runbooks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-569.000000, -306.000000)",
    fill: "#F3F3F3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-eye__not-allowed",
    transform: "translate(569.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.47,6.83 C14.8988655,5.33541314 13.9029615,4.04056417 12.605,3.105 L15,0.705 L14.295,0 L1,13.295 L1.705,14 L4.255,11.455 C5.39321235,12.1183713 6.68276277,12.4782058 8,12.5 C11.3310488,12.3747359 14.2680152,10.2791494 15.47,7.17 C15.5097164,7.0601462 15.5097164,6.9398538 15.47,6.83 Z M8,10.25 C7.31080139,10.2496839 6.63977286,10.0289277 6.085,9.62 L7,8.715 C7.77930743,9.14199121 8.74688923,9.00358455 9.37523689,8.37523689 C10.0035846,7.74688923 10.1419912,6.77930743 9.715,6 L10.62,5.095 C11.3382266,6.08146686 11.4423398,7.38746027 10.8894726,8.47525814 C10.3366054,9.56305602 9.22023144,10.2487436 8,10.25 Z M2.265,9.905 L4.765,7.405 C4.75199846,7.27041521 4.74698967,7.13517782 4.75,7 C4.75275332,5.20621626 6.20621626,3.75275332 8,3.75 C8.13203887,3.75070119 8.26392634,3.75904849 8.395,3.775 L10.285,1.89 C9.5494186,1.63735334 8.77773933,1.50564441 8,1.5 C4.6689512,1.62526414 1.73198477,3.72085062 0.53,6.83 C0.490283624,6.9398538 0.490283624,7.0601462 0.53,7.17 C0.914012987,8.19132169 1.50466423,9.12240593 2.265,9.905 Z",
    id: "Fill"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeNotAllowed);
export default __webpack_public_path__ + "static/media/icon-eye__not-allowed.acfb92150fcd74107f333f3e0c24a1de.svg";
export { ForwardRef as ReactComponent };